<div class="modal-overlay" (click)="onOverlayClick()">
  <div class="modal-content forgot-modal" (click)="$event.stopPropagation()">
    <!-- Close Button -->
    <button class="close-btn" (click)="onCloseModal()" aria-label="Close modal">
      <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      </svg>
    </button>

    <div class="modal-body">
      <div class="header-section">
        <h2>{{ t('forgotPasswordTitle') || 'Forgot your password?' }}</h2>
        <p>{{ t('forgotPasswordSubtitle') || 'Verify your details to securely reset your password.' }}</p>
      </div>

      <div class="vector-image">
        <img src="/svg/forgotPass.svg" alt="Forgot password illustration" />
      </div>

      <!-- Step 1: Verify details -->
      <form *ngIf="stage === 'verify'" [formGroup]="verifyForm" (ngSubmit)="onVerifySubmit()" class="forgot-form">
        <div class="form-group">
          <label for="fp-mobile" class="form-label">
            {{ t('forgotPasswordMobileLabel') || 'Registered Mobile Number' }}
          </label>
          <input
            id="fp-mobile"
            type="tel"
            formControlName="mobile"
            maxlength="10"
            class="form-input"
            [placeholder]="t('forgotPasswordMobilePlaceholder') || 'Enter your registered mobile number'"
            [class.error]="mobileControl?.invalid && (mobileControl?.touched || mobileControl?.dirty)"
          />
          <div class="error-message" *ngIf="mobileControl?.invalid && (mobileControl?.touched || mobileControl?.dirty)">
            <span *ngIf="mobileControl?.errors?.['required']">
              {{ t('forgotPasswordMobileRequired') || 'Mobile number is required.' }}
            </span>
            <span *ngIf="mobileControl?.errors?.['pattern']">
              {{ t('forgotPasswordMobileInvalid') || 'Please enter a valid 10 digit mobile number.' }}
            </span>
          </div>
        </div>

        <div class="form-group">
          <label for="fp-email" class="form-label">
            {{ t('forgotPasswordEmailLabel') || 'Registered Email ID' }}
          </label>
          <input
            id="fp-email"
            type="email"
            formControlName="email"
            class="form-input"
            [placeholder]="t('forgotPasswordEmailPlaceholder') || 'Enter your registered email'"
            [class.error]="emailControl?.invalid && (emailControl?.touched || emailControl?.dirty)"
          />
          <div class="error-message" *ngIf="emailControl?.invalid && (emailControl?.touched || emailControl?.dirty)">
            <span *ngIf="emailControl?.errors?.['required']">
              {{ t('forgotPasswordEmailRequired') || 'Email is required.' }}
            </span>
            <span *ngIf="emailControl?.errors?.['email']">
              {{ t('forgotPasswordEmailInvalid') || 'Please enter a valid email address.' }}
            </span>
          </div>
        </div>

        <div class="form-group">
          <label for="fp-dob" class="form-label">
            {{ t('forgotPasswordDobLabel') || 'Date of Birth' }}
          </label>
          <input
            id="fp-dob"
            type="date"
            formControlName="dob"
            class="form-input"
            lang="en-GB"
            [class.error]="dobControl?.invalid && (dobControl?.touched || dobControl?.dirty)"
          />
          <div class="error-message" *ngIf="dobControl?.invalid && (dobControl?.touched || dobControl?.dirty)">
            <span *ngIf="dobControl?.errors?.['required']">
              {{ t('forgotPasswordDobRequired') || 'Date of birth is required.' }}
            </span>
          </div>
        </div>

        <button type="submit" class="primary-btn" [disabled]="isLoading">
          <span *ngIf="!isLoading">{{ t('forgotPasswordVerifyButton') || 'Verify Details' }}</span>
          <span *ngIf="isLoading">{{ t('forgotPasswordVerifying') || 'Verifying...' }}</span>
        </button>
      </form>

      <!-- Step 2: Reset password -->
      <form *ngIf="stage === 'reset'" [formGroup]="resetForm" (ngSubmit)="onResetSubmit()" class="forgot-form">
        <div class="info-message">
          <p>{{ t('forgotPasswordResetInfo') || 'Details verified. Please enter your new password below.' }}</p>
        </div>

        <div class="form-group">
          <label for="fp-new-password" class="form-label">
            {{ t('forgotPasswordNewPasswordLabel') || 'New Password' }}
          </label>
          <input
            id="fp-new-password"
            type="password"
            formControlName="newPassword"
            class="form-input"
            [placeholder]="t('forgotPasswordNewPasswordPlaceholder') || 'Enter new password'"
            [class.error]="newPasswordControl?.invalid && (newPasswordControl?.touched || newPasswordControl?.dirty)"
          />
          <div class="error-message" *ngIf="newPasswordControl?.invalid && (newPasswordControl?.touched || newPasswordControl?.dirty)">
            <span *ngIf="newPasswordControl?.errors?.['required']">
              {{ t('forgotPasswordNewPasswordRequired') || 'New password is required.' }}
            </span>
            <span *ngIf="newPasswordControl?.errors?.['minlength']">
              {{ t('forgotPasswordNewPasswordMinLength') || 'Password must be at least 6 characters.' }}
            </span>
          </div>
        </div>

        <div class="form-group">
          <label for="fp-confirm-password" class="form-label">
            {{ t('forgotPasswordConfirmPasswordLabel') || 'Confirm New Password' }}
          </label>
          <input
            id="fp-confirm-password"
            type="password"
            formControlName="confirmPassword"
            class="form-input"
            [placeholder]="t('forgotPasswordConfirmPasswordPlaceholder') || 'Re-enter new password'"
            [class.error]="confirmPasswordControl?.invalid && (confirmPasswordControl?.touched || confirmPasswordControl?.dirty)"
          />
          <div class="error-message" *ngIf="confirmPasswordControl?.invalid && (confirmPasswordControl?.touched || confirmPasswordControl?.dirty)">
            <span *ngIf="confirmPasswordControl?.errors?.['required']">
              {{ t('forgotPasswordConfirmPasswordRequired') || 'Please confirm your new password.' }}
            </span>
          </div>
        </div>

        <button type="submit" class="primary-btn" [disabled]="isLoading">
          <span *ngIf="!isLoading">{{ t('forgotPasswordResetButton') || 'Reset Password' }}</span>
          <span *ngIf="isLoading">{{ t('forgotPasswordResetting') || 'Resetting...' }}</span>
        </button>
      </form>
    </div>
  </div>
</div>

